import { NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faGamepad,
  faArrowCircleUp,
  faArrowCircleDown,
  faUserCircle,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../context/ThemeContext';

type Tab = { to: string; label: string; icon: IconDefinition };

const TABS: Tab[] = [
  { to: '/home', label: 'Home', icon: faHome },
  { to: '/games', label: 'Games', icon: faGamepad },
  { to: '/topup', label: 'Top-Up', icon: faArrowCircleUp },
  { to: '/withdraw', label: 'Withdraw', icon: faArrowCircleDown },
  { to: '/profile', label: 'Profile', icon: faUserCircle },
];

const HIDDEN_PATHS = ['/wallet-topup', '/notifications', '/notification-prefs', '/faq', '/order'];

export default function BottomTabBar() {
  const { colors } = useTheme();
  const location = useLocation();

  if (HIDDEN_PATHS.some(p => location.pathname.startsWith(p))) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        height: `calc(68px + env(safe-area-inset-bottom, 0px))`,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        backgroundColor: colors.tabBar,
        borderTop: `1px solid ${colors.tabBarBorder}`,
        display: 'flex',
        zIndex: 100,
      }}
    >
      {TABS.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          style={({ isActive }) => ({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 4,
            paddingTop: 6,
            paddingBottom: 10,
            color: isActive ? colors.accentDark : colors.textMuted,
            textDecoration: 'none',
            fontSize: 10,
            fontWeight: 800,
          })}
        >
          {({ isActive }) => (
            <>
              <FontAwesomeIcon
                icon={tab.icon}
                style={{ fontSize: 20, color: isActive ? colors.accentDark : colors.textMuted }}
              />
              <span>{tab.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </div>
  );
}
